export const SERVICE_DISRUPTION_FLAG = 'claims-service-disruption';
export const SHUT_OFF_AUTOMATIC_EXERCISE = 'shut-off-automatic-exercise';
